import React from 'react';
import Attendance_Period from './Attendance_Period';
import '../../CommonCSS/SocietyCSS.css'

const Attendance_PeriodApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Attendance Period</h5>
          </div>  
        </div>
        <Attendance_Period/>
      </div>
    </div >
  );
};

export default Attendance_PeriodApp;
